import * as angular from "angular";

angular
  .module('bringoz.admin.oms')
  .constant('OmsOrders_PN', {
    database: 'orders',
    isBranchEntity: true
  });
